import { Component, OnInit, ViewChild, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Product, CartCreateDto, MapperSaleProduct, ProductOption } from '../../../../dto';
import { Utils } from '../../../../common';
import { CartService, ProductService, GaService } from '../../../../services';
import { BaseComponent } from '../../../../core';
import * as CartStore from '../../../../store/cart';
import * as IndicatorStore from '../../../../store/indicator';
import { trigger, transition, style, animate } from '@angular/animations';
import $ from 'jquery';
import * as SelectProductStore from '../../../../store/select-product';
import { takeWhile } from 'rxjs/operators';
import { PRODUCT_SHIPPING_TYPE } from './../../../../shared';

@Component({
  selector: 'app-select-product',
  templateUrl: './select-product.component.html',
  styleUrls: ['./select-product.component.scss'],
  animations: [
    trigger('enterAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('150ms', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate('150ms', style({ transform: 'translateX(100%)', opacity: 0 })),
      ]),
    ]),
  ],
})
export class SelectProductComponent extends BaseComponent implements OnInit, OnDestroy {
  selectedProduct: Product;
  isShowAddToCartModal: boolean;

  @ViewChild('scroll', { read: ElementRef, static: false })
  scroll: ElementRef;

  @Output()
  isOptionSelect = new EventEmitter<any>();

  constructor(private cartService: CartService, private productService: ProductService, private gaService: GaService) {
    super();
    this.productService.resetSubject$.pipe(takeWhile(() => this.isAlive)).subscribe(async (products) => {
      this.selectedProduct?.mapperSaleProducts.forEach((mapperSaleProduct) => {
        if (products === undefined) {
          mapperSaleProduct.optionCheck = false;
        } else {
          for (let i = 0; i < products.length; i++) {
            if (products[i].id === mapperSaleProduct.id) {
              mapperSaleProduct.optionCheck = true;
              return;
            } else {
              mapperSaleProduct.optionCheck = false;
            }
          }
        }
      });
    });
    this.productService.openOptionSubject$.subscribe((result) => {
      if (result) this.isShowAddToCartModal = false;
    });
    this.store
      .select(SelectProductStore.SELECT_PRODUCT_STORE_NAME)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((selectProductPayload) => {
        console.log(selectProductPayload);
        if (selectProductPayload && selectProductPayload.selectType === 0) {
          this.open(selectProductPayload.product);
          this.store.dispatch(new SelectProductStore.RemoveProduct());
        } else if (selectProductPayload?.selectType === 1) {
          console.log(selectProductPayload.product);
          this.selectedProduct = this.productService.mergeInvalidCountry(selectProductPayload.product);
          this.store.dispatch(new SelectProductStore.RemoveProduct());
          this.isShowAddToCartModal = true;
        }
      });
  }

  ngOnInit() {}

  checkUquickStockMoq(productOption: ProductOption) {
    if (!productOption.isFixedMoq && productOption.rocketStock) {
      if (productOption.rocketStock < 5) {
        productOption.minMoq = 1;
        productOption.inboxQuantity = 1;
      } else {
        if (productOption.minMoq === 1) {
          productOption.minMoq = 1;
          productOption.inboxQuantity = 1;
        } else {
          productOption.minMoq = 5;
          productOption.inboxQuantity = 5;
        }
      }
    }
    return productOption;
  }

  addToCart(selectedSaleProduct: MapperSaleProduct) {
    let setShippingType = () => {
      if (selectedSaleProduct.productOption.europeStock > 0) {
        return PRODUCT_SHIPPING_TYPE.UDIRECT;
      } else {
        return Utils.toNumber(selectedSaleProduct.productOption.minMoq) < selectedSaleProduct.productOption.rocketStock
          ? PRODUCT_SHIPPING_TYPE.GENERAL
          : Utils.toNumber(selectedSaleProduct.productOption.minMoq) <= selectedSaleProduct.productOption.rocketStock
          ? PRODUCT_SHIPPING_TYPE.ROCKET
          : Utils.toNumber(selectedSaleProduct.productOption.minMoq) <= selectedSaleProduct.productOption.stock
          ? PRODUCT_SHIPPING_TYPE.STOCK
          : PRODUCT_SHIPPING_TYPE.GENERAL;
      }
    };
    const saleProduct = new CartCreateDto({
      mapperSaleProductId: Utils.toNumber(selectedSaleProduct.id),
      quantity: Utils.toNumber(this.checkUquickStockMoq(selectedSaleProduct.productOption).minMoq),
      shippingType: setShippingType(),
    });
    this.cartService.addToCart(saleProduct).subscribe(
      (cart) => {
        const dialog = this._openDialog({
          message: this.i18n.t('CART.ADDED_MIN'),
          close: () => {
            dialog.close();
          },
        });
        this.store.dispatch(new CartStore.AddCart(cart));
        this.gaService.MOJI_AddToCart([cart]);
      },
      (error) => {
        this.store.dispatch(new IndicatorStore.HideIndicator('addToCart'));
        this.errors = error;
        const errorDialog = this._openDialog({
          message: this.errors.message,
          close: () => {
            errorDialog.close();
          },
        });
      }
    );
  }

  addToSelect(product) {
    if (product.productStatus === this.PRODUCT_STATUS.OUT_OF_STOCK) {
      return;
    }
    if (this.selectedProduct?.mapperSaleProducts.length > 1) {
      this.productService.addToSelect(product);
    }
  }

  public open(selectedProduct: Product) {
    console.log(selectedProduct.mapperSaleProducts);
    if (selectedProduct.mapperSaleProducts.length === 1) {
      this.addToCart(selectedProduct.mapperSaleProducts[0]);
    } else {
      this.selectedProduct = this.productService.mergeInvalidCountry(selectedProduct);
      this.isShowAddToCartModal = true;
      this.scrollHeight();
    }
  }

  onCloseAddToCartModal() {
    this.isShowAddToCartModal = false;
  }

  private scrollHeight() {
    // tslint:disable-next-line: deprecation
    $(document).ready(() => {
      const viewHeight = window.innerHeight - this.scroll.nativeElement.offsetTop - 20;
      this.scroll.nativeElement.style.maxHeight = viewHeight + 'px';
    });
  }
}
